import store from "store/index"
import { apiAction, gateAction } from "store/middleware/api"
import { showMagicToaster } from "utils/MagicToasterCall"
import moment from "moment"
import { setLists } from "store/modules/shop"
import { setCrtList, SET_TEMP_PRODUCT_LIST_DETAILS } from "store/modules/page"
import { addId } from "utils/lookupFunctions"
import { loadDynamoFormItemByPK_v2 } from "store/modules/dataView.search"
import { history } from "utils/history"
import { printError } from "utils/printError"
import { fetchShortDetailsByIdListJava } from "store/modules/dataView/dataViewActions.actions"
import { loadViewData } from "store/modules/dataView/dataView-dataLoader"

/** Admins work "on behalf" of a client organisation; the gate ignores this for customers. */
const listOrgId = () => store.getState()?.page?.onBehalfId || undefined

export const createNewList = ({ name, products = [], crtList }) => {
  const eDate = moment().toISOString()
  const SK = `ORG_LIST-${eDate}` //PK si SK erau
  const cDate = eDate
  // const cDate = values.cDate ?? eDate
  const { organizationId, name: userName, id } = store.getState()?.user ?? {}
  const PK = `ORG-${organizationId}`

  // const userId = store.getState()?.user?.id
  // const userName = store.getState()?.user?.name

  const safeToCreate = organizationId && name
  if (!safeToCreate) return { type: "a" }
  return gateAction({
    op: "saveList",
    body: { list: { SK, name, products }, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      dispatch(loadOrganizationLists({ crtList }))//: true
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("createNewList()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const createNewImport = ({ name, products = [] }) => {
  const eDate = moment().toISOString()
  const SK = `EIP_LIST-${eDate}` //PK si SK erau
  const cDate = eDate
  // const cDate = values.cDate ?? eDate
  const { organizationId, name: userName, id } = store.getState()?.user ?? {}
  const PK = `EIP-${organizationId}`

  // const userId = store.getState()?.user?.id
  // const userName = store.getState()?.user?.name

  const safeToCreate = organizationId && name
  if (!safeToCreate) return { type: "a" }
  // Excel import lists (EIP) have no route in the app and are not served by the gate.
  console.warn("createNewImport: not available through the data gate", PK, cDate, userName, id)
  return { type: "a" }
  // eslint-disable-next-line no-unreachable
  return gateAction({
    op: "saveList",
    body: { list: { SK, name, products } },
    onSuccess: (data, dispatch) => {
      dispatch(loadOrganizationLists({ crtList: true }))

      setTimeout(() => {
        history?.push?.(
          `/shop/importfromexcel/details?id=EIP-${organizationId}|EIP_LIST-${eDate}`
        )
      }, 700)

      return { type: "a" }
    },
    onFailure: (err) => {
      printError("createNewImport()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const addProductToList = ({ listItem, product }) => {
  const eDate = moment().toISOString()
  if(listItem) { listItem.eDate = eDate }
  const alreadyInList = listItem?.products?.find?.(
    (item) => item?.id === product.id
  )
  if (!alreadyInList)
    if(listItem) { listItem.products = [...(listItem?.products ?? []), product] }

  const safeToCreate = listItem?.PK && listItem?.SK && product && !alreadyInList
  if (!safeToCreate) return { type: "a" }
  return gateAction({
    op: "saveList",
    body: { list: listItem, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      dispatch(loadOrganizationLists())
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("addProductToList()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}
export const updateListQuantityAction = ({ productId, quantity }) => {
  const listItem = store.getState()?.page?.crtFormItem
  const products = store.getState()?.dataView?.items
  const eDate = moment().toISOString()
  if(listItem) { listItem.eDate = eDate }
  const alreadyInList = products?.find?.((item) => item?.id === productId)
  //listItem?.products?.find?.(item => item?.id === productId)
  if (!alreadyInList) {
    showMagicToaster({
      title: "A aparut o eroare la salvarea datelor",
      subtitle: "E203",
      type: "error"
    })
    return { type: "a" }
  }
  //listItem?.products?.forEach?.(item => {
  products?.forEach?.((item) => {
    if (item?.id === productId) {
      item.quantity = Number(quantity)
    }
  })
  if(listItem) { listItem.products = products }
  return gateAction({
    op: "saveList",
    body: { list: listItem, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      dispatch(loadOrganizationLists())
      dispatch(
        loadDynamoFormItemByPK_v2({
          input: listItem?.PK + "|" + listItem?.SK,
          setDvListProducts: true,
          moreSteps: enrichListFromJava
        })
      )
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("updateListQuantityAction()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}
export const addMultiProductsToList = ({ newProducts }) => {
  const listItem = store.getState()?.page?.crtFormItem
  const products = store.getState()?.dataView?.items
  const eDate = moment().toISOString()
  if(listItem) { listItem.eDate = eDate }
  const alreadyInListIds = products?.map?.((prod) => prod.id)
  //listItem?.products?.map?.(prod => prod.id)
  const newProductsFiltered = newProducts?.filter?.(
    (prod) => !alreadyInListIds?.includes?.(prod.id)
  )
  if(listItem) { 
    listItem.products = [ 
      ...(products?.length ? products : []), 
      ...(newProductsFiltered?.length ? newProductsFiltered : [])
    ] ?? []
  }
  const safeToCreate = listItem?.PK && listItem?.SK && products
  if (!safeToCreate) return { type: "a" }
  return gateAction({
    op: "saveList",
    body: { list: listItem, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      //dispatch(loadOrganizationLists())
      dispatch(
        loadDynamoFormItemByPK_v2({
          input: listItem?.PK + "|" + listItem?.SK,
          moreSteps: enrichListFromJava,
          setDvListProducts: true
        })
      )
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("addMultiProductsToList()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const addMultiProductsToList2 = ({ newProducts }) => {
  const listItem = store.getState()?.page?.crtFormItem
  const products = store.getState()?.dataView?.items
  const eDate = moment().toISOString()
  if(listItem) { listItem.eDate = eDate }
  const alreadyInListIds = products?.map?.((prod) => prod.id)
  //listItem?.products?.map?.(prod => prod.id)
  const newProductsFiltered = newProducts?.filter?.(
    (prod) => !alreadyInListIds?.includes?.(prod.id)
  )
  if(listItem) { listItem.products = [...products || [], ...newProductsFiltered || []] ?? [] }

  const safeToCreate = listItem?.PK && listItem?.SK && products
  if (!safeToCreate) return { type: "a" }
  return gateAction({
    op: "saveList",
    body: { list: listItem, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      //dispatch(loadOrganizationLists())
      dispatch(
        loadDynamoFormItemByPK_v2({
          input: listItem?.PK + "|" + listItem?.SK,
          moreSteps: enrichListFromJava2,
          setDvListProducts: true
        })
      )
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("addMultiProductsToList2()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const deleteProductsFromList = ({ products }) => {
  let listItem = store.getState()?.page?.crtFormItem
  const eDate = moment().toISOString()
  if(listItem) { 
    listItem.eDate = eDate
    listItem.products = products ?? []
  }
  const safeToCreate = listItem?.PK && listItem?.SK && listItem?.products
  if (!safeToCreate) return { type: "a" }
  return gateAction({
    op: "saveList",
    body: { list: listItem, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      dispatch(loadOrganizationLists())
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("deleteProductsFromList()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}
export const updateListNameDescription = (
  list,
  newName,
  newDescriptionValue
) => {
  const eDate = moment().toISOString()
  list.eDate = eDate
  // const alreadyInList = list.products?.find?.(item => item?.id === product.id)
  // if (!alreadyInList)
  //     list.products = [...(list.products ?? []), product]
  list.name = newName
  list.description = newDescriptionValue
  const safeToUpdate = list?.SK && list?.PK && newName
  if (!safeToUpdate) return { type: "a" }
  return gateAction({
    op: "saveList",
    body: { list: list, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      dispatch(loadOrganizationLists())
      dispatch(
        loadDynamoFormItemByPK_v2({
          input: list?.PK + "|" + list?.SK,
          moreSteps: enrichListFromJava
        })
      )
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("updateListNameDescription()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const deleteList = (PK, SK) => {
  const safeToDelete = PK && SK
  if (!safeToDelete) {
    printError("deleteList(), PK and SK cannot be empty. ", {
      PK,
      SK
    })
    return { type: "a" }
  }
  return gateAction({
    op: "deleteList",
    body: { sk: SK, orgId: PK?.replace?.(/^ORG-/, "") },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost sterse" })
      dispatch(loadOrganizationLists())
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("deleteList()", err)
      showMagicToaster({
        title: "A aparut o eroare la stergerea listei",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const enrichListFromJava = (data, dispatch) => {
  const listOfIds = data?.products?.map?.((item) => ({
    // dispatch(fetchProdDetailsForList(item?.id))
    "id": item?.id
  }))
  dispatch(fetchShortDetailsByIdListJava(listOfIds, SET_TEMP_PRODUCT_LIST_DETAILS))
}

export const enrichListFromJava2 = (data, dispatch) => {
  data?.products?.forEach?.((item) => {
    dispatch(fetchProdDetailsForList2(item?.productCode))
  })
}

const fetchProdDetailsForList = (id) =>
  apiAction({
    endPoint: `/product/goods/shop/` + id,
    onSuccess: (data, dispatch) => {
      return { type: SET_TEMP_PRODUCT_LIST_DETAILS, payload: data }
    },
    onFailure: (error) => {
      printError("fetchProdDetailsForList()", error)
      return {
        type: "a"
      }
    }
  })

const fetchProdDetailsForList2 = (productCode) =>
  apiAction({
    endPoint: `/product/goods/shop/code/` + productCode,
    onSuccess: (data, dispatch) => {
      return { type: SET_TEMP_PRODUCT_LIST_DETAILS, payload: data }
    },
    onFailure: (error) => {
      printError("fetchProdDetailsForList2()", error)
      return {
        type: "a"
      }
    }
  })

export const deleteProductFromList = (list, id) => {
  const eDate = moment().toISOString()
  let stateList = store.getState()?.page?.crtFormItem
  const products = store.getState()?.dataView?.items
  const listItem = list ?? stateList
  const alreadyInList = products?.find?.((item) => item?.id === id)
  //listItem?.products?.find?.(item => item?.id === id)
  const safeToDelete = listItem?.PK && listItem?.SK && id && alreadyInList
  if (!safeToDelete) return { type: "a" }
  if (alreadyInList)
  if(listItem) { 
    listItem.products = products?.filter?.((item) => item?.id !== id)
    listItem.eDate = eDate
  }
  //listItem?.products?.filter?.(item => item?.id !== id)
  return gateAction({
    op: "saveList",
    body: { list: listItem, orgId: listOrgId() },
    onSuccess: (data, dispatch) => {
      // dispatch(loadOrganizationLists())
      dispatch(
        loadDynamoFormItemByPK_v2({
          input: listItem?.PK + "|" + listItem?.SK,
          setDvListProducts: true,
          moreSteps: enrichListFromJava
        })
      )
      showMagicToaster({ title: "Datele au fost sterse" })
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("deleteProductFromList()", err)
      showMagicToaster({
        title: "A aparut o eroare la stergerea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

export const loadOrganizationLists = (props) => {
  const crtList = props?.crtList
  const SKprefix = `ORG_LIST-`
  // const cDate = values.cDate ?? eDate
  // const userId = store.getState()?.user?.id

  const state = store.getState()
  const organizationId = state?.page?.onBehalfId || state?.user?.organizationId

  const PK = `ORG-${organizationId}`

  return gateAction({
    op: "listOrgLists",
    body: { orgId: organizationId },
    onSuccess: (data, dispatch) => {
      if (crtList) dispatch(setCrtList({ items: addId(data?.items) ?? [] }))
      else dispatch(setLists(data?.items ?? []))
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("loadOrganizationLists()", err)
      // showMagicToaster({title: err})

      return {
        type: "a"
      }
    }
  })
}

export const loadImports = (props) => {
  const crtList = props?.crtList
  const SKprefix = `EIP_LIST-`
  // const cDate = values.cDate ?? eDate
  // const userId = store.getState()?.user?.id
  const { organizationId } = store.getState()?.user

  const PK = `EIP-${organizationId}`

  // Excel import lists (EIP) have no route in the app and are not served by the gate.
  console.warn("loadImports: not available through the data gate", PK, SKprefix)
  return { type: "a" }
  // eslint-disable-next-line no-unreachable
  return gateAction({
    op: "listOrgLists",
    body: { orgId: organizationId },
    onSuccess: (data, dispatch) => {
      if (crtList) dispatch(setCrtList({ items: addId(data?.items) ?? [] }))
      else dispatch(setLists(data?.items ?? []))
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("loadImports()", err)
      // showMagicToaster({title: err})

      return {
        type: "a"
      }
    }
  })
}

export const deleteDataViewSelectedRowsFromDynamoDB = (inSK, selectedItems) => {
  return gateAction({
    op: "adminBatchDelete",
    body: { sk: inSK, pks: selectedItems ?? [] },
    onSuccess: (data, dispatch) => {
      showMagicToaster({ title: "Datele au fost salvate" })
      dispatch(loadViewData())
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("deleteDataViewSelectedRowsFromDynamoDB()", err)
      showMagicToaster({
        title: "A aparut o eroare la salvarea datelor",
        subtitle: "E201",
        type: "error"
      })
      return {
        type: "a"
      }
    }
  })
}

